var _text;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBatteryUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBCBC"
    },
    d: "M464,174.4L464,174.4c12.8,0,24,10.4,24,24v100c0,12.8-11.2,24-24,24l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9AAA9"
    },
    d: "M464.8,168H464v-16c0-19.2-14.4-32-32.8-32H32.8C15.2,120,0,133.6,0,152v192c0,19.2,15.2,32,32.8,32 h398.4c17.6,0,32.8-13.6,32.8-32v-16h0.8c17.6,0,31.2-12.8,31.2-29.6V197.6C496,180.8,482.4,168,464.8,168z M448,344 c0,10.4-7.2,16-16.8,16H32.8C24,360,16,353.6,16,344V152c0-10.4,8-16,16.8-16h398.4c9.6,0,16.8,6.4,16.8,16L448,344L448,344z  M480,298.4c0,8.8-6.4,13.6-15.2,13.6H464V184h0.8c8.8,0,15.2,4.8,15.2,13.6V298.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9BBB9"
    },
    d: "M263.2,360H32.8C24,360,16,353.6,16,344V152c0-6.4,3.2-10.4,8-14.4L11.2,128C4,133.6,0,141.6,0,152 v192c0,19.2,15.2,32,32.8,32H280L263.2,360z"
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    fontSize: 250,
    fontWeight: "bold",
    fill: "#A9AAA9",
    dy: 30
  }, "?")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryUnknown);
export default __webpack_public_path__ + "static/media/batteryUnknown.da5f1a4dd838c0951a0f7945220816de.svg";
export { ForwardRef as ReactComponent };